import styled from 'styled-components'

export const Introduction = styled.section`
  height: 100vh; /* pełna wysokość okna */
  position: relative;
  background-color: rgba(224, 243, 246, 0.2); /* półprzezroczyste tło */
  padding: 20px;
  border-radius: 8px;
  scroll-snap-align: start;

  @media (max-width: 768px) {
    min-height: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`

export const BoxIntroduction = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  max-width: 550px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 20px;
  border-radius: 12px;
  text-align: right;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 40px;

  @media (max-width: 768px) {
    position: static;
    max-width: 100%;
    margin-top: 20px;
    text-align: center;
  }
`
export const Heading = styled.h1`
  text-align: center;
  font-size: 2rem; /* zwiększa rozmiar czcionki */
  font-weight: bold; /* pogrubienie */
  color: rgb(71, 120, 128); /* bardziej wyrazisty kolor */
  margin-bottom: 20px;
  margin-top: 20px;
  text-transform: uppercase; /* opcjonalnie: wielkie litery */
  text-shadow: 2px 2px 4px rgba(65, 64, 64, 0.5);
`
export const WelcomeContent = styled.article`
  text-align: center;
`
export const HeroImage = styled.img`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 20px;
    object-fit: contain;
  }
`
